export const Hero = () => {
    return (
        <>
            <section className="h-dvh w-full m-2 flex justify-center">
                <div className="flex justify-center w-3/5 m-2">
                    <div className="p-2 flex items-start flex-col">
                        <h2 className="text-4xl mt-4">Your Property, Your Investment</h2>
                        <h3 className="text-3xl mt-4">
                            Make Data-Driven Decisions with Confidence
                        </h3>
                        <p className="mt-4">
                            Get certainty in the ROI with the Property Search tool and property market insights in the Market section.
                        </p>
                        <div className="mt-4">
                            <button className="bg-slate-500 hover:bg-slate-600 active:bg-slate-700 focus:outline-none focus:ring focus:ring-violet-300 p-4 rounded-xl">Start for free</button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
